export function coerceFilterValues(value) {
  if (value === undefined || value === null || value === '') {
    return [];
  }

  return Array.isArray(value) ? value : [String(value)];
}

export function toggleMultiFilterValue(selected, value) {
  const current = coerceFilterValues(selected);
  const checked = current.includes(value);
  const next = checked
    ? current.filter((item) => item !== value)
    : [...current, value];

  if (next.length === 0) {
    return undefined;
  }

  return next;
}

function resolveOptionLabel(options, optionValue) {
  const match = options.find((option) => option.value === optionValue);
  return match?.label ?? optionValue;
}

function extractCodeFromLabel(label) {
  return String(label).split(' - ')[0]?.trim() ?? String(label);
}

export function sortFilterLabelsByCode(labels = []) {
  return [...labels].sort((a, b) => (
    extractCodeFromLabel(a).localeCompare(extractCodeFromLabel(b), 'zh-Hant', { numeric: true })
  ));
}

export function resolveMultiFilterSummary(selected, options = []) {
  const values = coerceFilterValues(selected);

  if (values.length === 0) {
    return '全部';
  }

  if (values.length === 1) {
    const label = resolveOptionLabel(options, values[0]);
    return label === values[0] ? '已選 1 項' : label;
  }

  return `已選 ${values.length} 項`;
}

export function resolveMultiFilterLabels(selected, options = []) {
  const labels = coerceFilterValues(selected).map((value) => {
    const label = resolveOptionLabel(options, value);
    return label === value ? value : label;
  });

  return sortFilterLabelsByCode(labels);
}
